<template>
  <v-container class="pt-8 pb-0">
    <!-- Color del cuaderno -->
    <v-row>
      <v-col class="py-0 pr-0" cols="8">
        <v-slider
          :label="t.cuaderno.color"
          :min="0"
          :max="13"
          step="1"
          thumb-size="0"
          v-model="cuaderno.color"
        >
        </v-slider>
      </v-col>
      <v-col class="py-0 px-0" cols="4">
        <v-slider
          :min="3"
          :max="5"
          step="1"
          thumb-size="0"
          v-model="cuaderno.light"
        >
        </v-slider>
      </v-col>
    </v-row>

    <!-- Vista -->
    <v-row align="center" align-content="center">
      <v-col class="py-0" cols="8">
        <v-radio-group :label="t.cuaderno.mostrarEn" v-model="cuaderno.vista">
          <v-radio
            on-icon="radio_button_checked"
            off-icon="radio_button_unchecked"
            :label="t.cuaderno.tuOraDia"
            value="dia"
          ></v-radio>
          <v-radio
            on-icon="radio_button_checked"
            off-icon="radio_button_unchecked"
            :label="t.cuaderno.resumMes"
            value="mes"
          ></v-radio>
          <v-radio
            on-icon="radio_button_checked"
            off-icon="radio_button_unchecked"
            :label="t.cuaderno.ambos"
            value="ambos"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="4" class="px-1">
        <v-container class="cuaderno" :class="color">
          <v-row align-content="end" justify="center">
            <v-icon v-show="iconDia">today</v-icon>
          </v-row>
          <v-row align-content="start" justify="center">
            <v-icon v-show="iconMes">calendar_view_day</v-icon>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "user-cuaderno",
  props: ["cuaderno"],
  data() {
    return {
      colors: [
        "pink",
        "purple",
        "deep-purple",
        "indigo",
        "blue",
        "light-blue",
        "cyan",
        "teal",
        "green",
        "light-green",
        "lime",
        "yellow",
        "amber",
        "orange",
        "deep-orange",
        "blue-grey"
      ]
    };
  },
  computed: {
    color() {
      return (
        this.colors[this.cuaderno.color] + " lighten-" + this.cuaderno.light
      );
    },
    iconDia() {
      return this.cuaderno.vista === "dia" || this.cuaderno.vista === "ambos";
    },
    iconMes() {
      return this.cuaderno.vista === "mes" || this.cuaderno.vista === "ambos";
    },
    rules() {
      // let _this = this;
      return {
        required: value => !!value || "No puede ser vacio.",
        counter: value => value.length <= 35 || "35 caracteres máximo.",
        selectOne: value => !!value || "Elija una opción.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail incorrecto.";
        }
      };
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  }
};
</script>

<style>
.cuaderno {
  display: flex;
  flex-flow: column;
  min-height: 125px;
  border-radius: 8px;
}
</style>
